//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
    chipTypes, userIcon, groupIcon, fileIcon
} from "./consts";

export default {
    props: {
        noIcon: { type: Boolean, default: false },
        content: null,
        innerContent: {
            type: String,
            default: ""
        },
        iconLeft: {
            type: Object,
            default() {
                return {
                    icon: null,
                    iconSize: null
                };
            }
        },
        type: {
            type: String,
            default: "default",
            // one of these ['default', 'unknownUser', 'disabledUser', ' user', 'group', 'file', 'm_datamodel', 's_datamodel']
            validator: v => chipTypes.includes(v)
        },
        fromInnerMenu: {
            type: Boolean,
            default: false
        },
        clearable: {
            type: Boolean,
            default: false
        },
        fontWeight: {
            type: Number,
            default: 500
        },
        height: {
            type: Number,
            default: 20
        },
        fontSize: {
            type: Number,
            default: 12
        },
        textColor: {
            type: String,
            default: ""
        },
        backgroundColor: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            clearableColor: "",
            isChipActive: false,
            iconName: "mdi-close"
        };
    },
    computed: {
        setChipProp() {
            const types = {
                default: {
                    classType: "static-default",
                    icon: this.iconLeft.name || null,
                    iconSize: this.iconLeft.size || "16px"
                },
                unknownUser: {
                    classType: "static-unknownUser",
                    icon: this.iconLeft.name || null,
                    iconSize: this.iconLeft.size || "16px"
                },
                disabledUser: {
                    classType: "static-disabled-user",
                    icon: this.iconLeft.name || userIcon.name,
                    iconSize: this.iconLeft.size || "16px"
                },
                user: {
                    classType: "static-user",
                    icon: this.iconLeft.name || userIcon.name,
                    iconSize: this.iconLeft.size || "16px"
                },
                group: {
                    classType: "static-group",
                    icon: this.iconLeft.name || groupIcon.name,
                    iconSize: this.iconLeft.size || "16px"
                },
                file: {
                    classType: "static-file",
                    icon: this.iconLeft.name || fileIcon.name,
                    iconSize: this.iconLeft.size || "16px"
                },
                m_datamodel: {
                    classType: "datamodel-variable-format",
                    icon: this.iconLeft.name || null,
                    iconSize: this.iconLeft.size || "16px"
                },
                s_datamodel: {
                    classType: "system-variable-format",
                    icon: this.iconLeft.name || null,
                    iconSize: this.iconLeft.size || "16px"
                }
            };
            return types[this.type] || {};
        },
        isDataModel() {
            return ["m_datamodel", "s_datamodel"].includes(this.type);
        },
        getInnerDMClass() {
            return this.type === "m_datamodel" ? "inner-data-model" : "inner-system-variable";
        }
    },
    watch: {
        content: {
            handler(newV) {
                if (typeof newV === "string" && newV.includes("+")) {
                    setTimeout(() => {
                        this.$emit("change", "change");
                    }, 0);
                }
            },
            immediate: true
        }
    },
    mounted() {
        this.$emit("chipMounted", "mounted");
    },
    destroyed() {
        this.$emit("chipDestroyed", "destroyed");
    },
    methods: {
        changeIcon(hover) {
            this.iconName = hover ? "mdi-close-circle" : "mdi-close";
        },
        clickEvt(evt) {
            this.$emit("click", { event: evt, content: this.content });
        },
        deleteChip(evt) {
            this.$emit("deleteChip", { event: evt, content: this.content });
        }
    }
};
